import * as React from 'react'
import { inject, observer } from 'mobx-react'
import ActionsLocalService from '../../Services/ActionsLocalService'
import ConfigStore from '../../Stores/ConfigStore'

export interface IPageSizeComponentProps {
    actionsLocalService?: ActionsLocalService,
    configStore?: ConfigStore
}

@inject('actionsLocalService')
@inject('configStore')
@observer
export default class PageSizeComponent extends React.Component<IPageSizeComponentProps> {
    render() {
        const { actionsLocalService, configStore } = this.props
        return (

            <select
                className="select"
                value={configStore!.getPageSize}
                onChange={(e: React.ChangeEvent<any>) => {
                    actionsLocalService!.setPageSize(e.target.value)
                    return
                }
                }
            >
                <option value="1">1</option>
                <option value="3">3</option>
                <option value="5">5</option>
                <option value="15">15</option>
                <option value="30">30</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="250">250</option>
                <option value="500">500</option>
                <option value="1000">1000</option>
            </select>
            // <input type="text" pattern="[0-9]*"
            //     onFocus={(e) => {
            //         actionsLocalService!.setPageSize(60)
            //     }} />
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Components/PageSizeComponent/index.tsx